import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { BoxProps } from '@mui/material';
import clsx from 'clsx';

import colors from '@/common/colors';
import Badge from './Badge';

const useStyles = makeStyles({
  newBadge: {
    borderColor: colors.gray400
  }
});

/**
 * @deprecated Use `@noqo/clients/web/shared-components/atoms/Button` instead.
 */
const NewBadge = (props: BoxProps): JSX.Element => {
  const { className } = props;
  const classes = useStyles();

  return (
    <Badge
      {...props}
      text="NEW"
      dataTestId="new-badge"
      className={clsx(classes.newBadge, className)}
      alert
    />
  );
};

export default NewBadge;
